import { render, staticRenderFns } from "./MonthlySocsoCIMB.vue?vue&type=template&id=bbb1ce5a"
import script from "./MonthlySocsoCIMB.vue?vue&type=script&lang=js"
export * from "./MonthlySocsoCIMB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports